module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "complaint_details",
    staticStyle: {
      "padding-bottom": "2.7rem"
    }
  }, [(_vm.processType == 0) ? _c('div', [_c('div', {
    staticClass: "details"
  }, [_c('ul', {
    staticClass: "details_content"
  }, [_c('li', [_c('span', {
    staticClass: "details_tit"
  }, [_vm._v("商家名称:")]), _c('span', {
    staticClass: "details_con"
  }, [_vm._v(_vm._s(_vm.refundDetails.shopName))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "details_tit"
  }, [_vm._v("订单号码:")]), _c('span', {
    staticClass: "details_con"
  }, [_vm._v(_vm._s(_vm.refundDetails.orderId))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "details_tit"
  }, [_vm._v("申请金额:")]), _c('span', {
    staticClass: "details_con",
    staticStyle: {
      "color": "#f2596c"
    }
  }, [_vm._v("￥" + _vm._s(_vm.refundDetails.refundAmount))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "details_tit"
  }, [_vm._v("申请商品:")]), _c('span', {
    staticClass: "details_con"
  }, [_vm._v(_vm._s(_vm.refundDetails.refundGoodsDetail))])]), _vm._v(" "), (_vm.refundDetails.showResult == 1) ? _c('li', [_c('span', {
    staticClass: "details_tit"
  }, [_vm._v("退款金额:")]), _c('span', {
    staticClass: "details_con",
    staticStyle: {
      "color": "#F2596C"
    }
  }, [_vm._v("￥" + _vm._s(_vm.refundDetails.realrefundAmount))])]) : _vm._e(), _vm._v(" "), (_vm.refundDetails.showResult == 1) ? _c('li', [_c('span', {
    staticClass: "details_tit"
  }, [_vm._v("退款商品:")]), _c('span', {
    staticClass: "details_con"
  }, [_vm._v(_vm._s(_vm.refundDetails.finalRefundGoodsDesc))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "process"
  }, [_c('ul', {
    staticClass: "process_content"
  }, _vm._l((_vm.refundDetails.messageList), function(item) {
    return _c('li', {
      staticClass: "clearfix"
    }, [_c('div', {
      staticClass: "process_time"
    }, [_vm._v(_vm._s(item.handleDate))]), _vm._v(" "), (item.title) ? _c('div', {
      staticClass: "process_box"
    }, [_c('span', {
      class: ['process_icon fl', {
        'active': item.selected === 1
      }]
    }), _vm._v(" "), _c('span', {
      class: ['process_tit fl', {
        'active': item.selected === 1
      }]
    }, [_vm._v(_vm._s(item.title))])]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "process_des",
      domProps: {
        "innerHTML": _vm._s(item.refundGoodsStr)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "process_des",
      domProps: {
        "innerHTML": _vm._s(item.message)
      }
    })])
  }), 0)]), _vm._v(" "), (_vm.refundDetails.showAccept == 1 || _vm.refundDetails.showAppealStaus == 1) ? _c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "background": "#f6f6f6"
    }
  }, [(_vm.refundDetails.showAccept == 1) ? _c('div', {
    staticClass: "btn-big btn-yellow",
    on: {
      "click": _vm.acceptResult
    }
  }, [_c('h4', [_vm._v("接受商家处理结果")]), _vm._v(" "), _c('p', [_vm._v("(退款金额立即到账)")])]) : _vm._e(), _vm._v(" "), (_vm.refundDetails.showAppealStaus == 1) ? _c('div', {
    staticClass: "btn-big",
    on: {
      "click": _vm.confirmAppeal
    }
  }, [_c('h4', [_vm._v("退款申诉")]), _vm._v(" "), _c('p', [_vm._v("(商家处理后72h内可发起申诉，超时将默认您接受商家处理结果)")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.refundDetails.isCanCancel == 1) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.cancelComplaint
    }
  }, [_vm._v("撤销退款申请")]) : _vm._e(), _vm._v(" "), (_vm.refundDetails.showAppealStaus == 2) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.handleClickAppeal(2)
      }
    }
  }, [_vm._v("撤销退款申诉")]) : _vm._e()]) : _c('div', [_c('div', {
    staticClass: "details"
  }, [_c('h3', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("投诉详情")]), _vm._v(" "), _c('ul', {
    staticClass: "details_content"
  }, [_c('li', [_c('span', {
    staticClass: "details_tit"
  }, [_vm._v("商家名称:")]), _c('span', {
    staticClass: "details_con"
  }, [_vm._v(_vm._s(_vm.details.supplierShortName))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "details_tit"
  }, [_vm._v("订单号码:")]), _c('span', {
    staticClass: "details_con"
  }, [_vm._v(_vm._s(_vm.details.orderId))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "details_tit"
  }, [_vm._v("投诉对象:")]), _c('span', {
    staticClass: "details_con"
  }, [_vm._v(_vm._s(_vm.responsibleParty))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "details_tit"
  }, [_vm._v("投诉理由:")]), _c('span', {
    staticClass: "details_con"
  }, [_vm._v(_vm._s(_vm.details.complainReason))])]), _vm._v(" "), (_vm.details.compainComment != '') ? _c('li', [_c('span', {
    staticClass: "details_tit"
  }, [_vm._v("详细描述:")]), _c('span', {
    staticClass: "details_con"
  }, [_vm._v(_vm._s(_vm.details.compainComment))])]) : _vm._e(), _vm._v(" "), (_vm.details.afterSaleType == 1) ? _c('li', [_c('span', {
    staticClass: "details_tit"
  }, [_vm._v("订单金额:")]), _c('span', {
    staticClass: "details_con"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.details.realAmount != '' && _vm.details.realAmount != null),
      expression: "details.realAmount!='' && details.realAmount!=null"
    }]
  }, [_vm._v("￥")]), _vm._v(_vm._s(_vm.details.realAmount))])]) : _vm._e()]), _vm._v(" "), (_vm.urls.length > 0) ? _c('PreviewPicture', {
    staticClass: "details_pic",
    attrs: {
      "previewPictures": _vm.urls
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "process"
  }, [_c('ul', {
    staticClass: "process_content"
  }, _vm._l((_vm.details.messageList), function(item) {
    return _c('li', {
      staticClass: "clearfix"
    }, [_c('div', {
      staticClass: "process_time"
    }, [_vm._v(_vm._s(item.handleDate))]), _vm._v(" "), _c('div', {
      staticClass: "process_box"
    }, [_c('span', {
      class: ['process_icon fl', {
        'active': item.selected === 1
      }]
    }), _vm._v(" "), _c('span', {
      class: ['process_tit fl', {
        'active': item.selected === 1
      }]
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('p', {
      staticClass: "process_des"
    }, [_vm._v(_vm._s(item.message))])])
  }), 0)]), _vm._v(" "), (_vm.details.afterSaleType == 1) ? _c('div', [(_vm.details.canCancel == 1) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.cancelComplaint
    }
  }, [_vm._v("取消投诉")]) : _vm._e(), _vm._v(" "), (_vm.messageList.length >= 2 && _vm.details.resultFeedBack == 0 && _vm.details.canCancel == 1) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.toFeedBack
    }
  }, [_vm._v("投诉反馈")]) : _vm._e()]) : _c('div', [(_vm.details.canCancel == 1) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.cancelComplaint
    }
  }, [_vm._v("取消售后")]) : _vm._e(), _vm._v(" "), (_vm.messageList.length == 4 && _vm.details.resultFeedBack == 0) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.toFeedBack
    }
  }, [_vm._v("售后反馈")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAppealAlert),
      expression: "showAppealAlert"
    }],
    staticClass: "appeal-alert mask"
  }, [_c('div', {
    staticClass: "appeal-alert-box"
  }, [_c('h3', [_vm._v("退款申诉")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appealReason),
      expression: "appealReason"
    }],
    attrs: {
      "placeholder": "请输入申诉理由，不超过200字",
      "maxlength": "200"
    },
    domProps: {
      "value": (_vm.appealReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.appealReason = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "appeal-description"
  }, [_vm._v("发起申诉后，您的此笔退款订单将由俺来也平台\n        介入审核。期间您可能会收到俺来也平台的客服\n        电话，请保持手机畅通。审核约需1-3个工作日。")]), _vm._v(" "), _c('div', {
    staticClass: "appeal-btn flexrow"
  }, [_c('span', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.showAppealAlert = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "submit",
    on: {
      "click": function($event) {
        return _vm.handleClickAppeal(1)
      }
    }
  }, [_vm._v("提交申诉")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "line"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "line"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-285b0f62","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/CheckComplaints.vue
// module id = 420
// module chunks = 7